import {Routes} from '@angular/router';
import {AuthInfo} from '../../components/security/authorization/auth.guard';
import {VerifyEmailChangePageComponent} from './verify/verify-email-change-page.component';

/**
 * Created by Rodrigo Quesada on 14/08/17.
 */
const routes: Routes = [{
    path: 'account',
    data: {auth: new AuthInfo({allowUnauthorizedUsers: true}), withSectionNav: false},
    children: [
        {path: '', redirectTo: 'verify-email-change', pathMatch: 'full'},
        {path: 'verify-email-change', component: VerifyEmailChangePageComponent}
    ]
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/account/account-page.routing.ts